import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import RichText from 'dpl/prismic/components/RichText';

export default function TableRow({ isHead, isLast, row }) {
  const columns = Object.values(row);

  return (
    <tr
      className={classnames('PrismicTableRow', {
        'bb b--moon-gray': !isHead && !isLast,
        'bb bw1 b--black': isHead
      })}
      data-test-id="PrismicTableRow"
    >
      {columns.map((value, idx) => {
        const CellComponent = isHead || idx === 0 ? 'th' : 'td';

        return (
          <CellComponent
            className={classnames('PrismicTableCell ph3 pv2', {
              'bl b--moon-gray': idx !== 0
            })}
            data-test-id="PrismicTableCell"
            key={idx}
          >
            {value && <RichText content={value} />}
          </CellComponent>
        );
      })}
    </tr>
  );
}

TableRow.propTypes = {
  isHead: PropTypes.bool,
  isLast: PropTypes.bool,
  row: PropTypes.arrayOf(StructuredTextPropTypes).isRequired
};

TableRow.defaultProps = {
  isHead: false,
  isLast: false
};
